<script setup lang="ts">
import { useElementSize } from '@vueuse/core';
import { AppCoreEnums } from '../shared/enums';
import AppButton from './common/app-button.vue';
import { PropType, ref, watchEffect } from 'vue';
import { IAppToolbarItem } from '../../stores/core/models';
import AppToolbarItemButtonMenu from './app-toolbar-item-button-menu.vue';

defineEmits(['click']);

const width = defineModel<number | undefined>('width');

const props = defineProps({
  item: {
    type: Object as PropType<IAppToolbarItem>,
    required: true,
  },
});

const itemRef = ref(null);
const { width: itemWidth } = useElementSize(itemRef);

watchEffect(() => (width.value = Math.ceil(itemWidth.value)));
</script>

<template>
  <div ref="itemRef">
    <app-button
      v-if="!props.item.itemType || props.item.itemType == AppCoreEnums.ToolbarItemTypes.Button"
      :icon="props.item.icon"
      :label="props.item.label"
      @click="$emit('click')"
      :icon-img="props.item.iconImg"
      :icon-img-dark="props.item.iconImgDark"
      :outlined="!props.item.isPrimary"
      :disabled="props.item.disabled"
      :tooltip="props.item.tooltip ? props.item.tooltip : undefined"
      :severity="props.item.severity"
      :permission="props.item.permission"
    />
    <ToggleSwitch
      v-else-if="props.item.itemType == AppCoreEnums.ToolbarItemTypes.InputSwitch"
      :disabled="props.item.disabled"
      :model-value="props.item.modelValue"
      v-tooltip.bottom="props.item.tooltip ? $t(props.item.tooltip) : undefined"
      :ptOptions="{ mergeSections: true, mergeProps: true }"
      :pt="{
        root: '!h-5 ',
      }"
      @click="$emit('click')"
    />

    <app-toolbar-item-button-menu
      :item="props.item"
      v-else-if="props.item.itemType == AppCoreEnums.ToolbarItemTypes.ButtonMenu"
      use-btn
    />
  </div>
</template>
